<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row mt-20 playground">
      <!-- BEGIN BARIS 1  -->
      <div class="col-md-3">
        <Sidebar />
      </div>
      <div class="col-md-9">
        <Topbar />

        <div class="card custom-card mt-4">
          <div class="card-body pt-5 pl-0 pr-0 pb-0">
            <div class="pl-4 pr-4">
              <div class="float-right">
                <img :src="siteLogo()" alt="Logo" width="40" />
              </div>
              <div>
                <h1 class="judul">
                  Share of people who received at least one dose of COVID-19
                  vaccine
                </h1>
                <p
                  style="
                    font-size: 12.8px;
                    line-height: 1.2;
                    overflow-y: hidden;
                    color: #666;
                    -webkit-font-smoothing: antialiased;
                  "
                >
                  Share of the total population that received at least one
                  vaccine dose. This may not equal the share that are fully
                  vaccinated if the vaccine requires two doses.
                </p>
              </div>
            </div>
            <div class="chart" ref="myEchart" />
            <span
              class="pl-4"
              style="
                font-size: 11.2px;
                line-height: 1.1;
                color: rgb(119, 119, 119);
              "
            >
              Source: Center of Data and Information, Ministry of Health
            </span>

            {{ tab }}
            <div>
              <b-nav tabs justified class="tabs-below mt-8">
                <b-nav-item :active="tab === 1" @click="tab = 1">
                  CHART
                </b-nav-item>
                <b-nav-item :active="tab === 2" @click="tab = 2">
                  MAP
                </b-nav-item>
                <b-nav-item :active="tab === 3" @click="tab = 3">
                  TABLE
                </b-nav-item>
                <b-nav-item :active="tab === 4" @click="tab = 4">
                  SOURCES
                </b-nav-item>
                <b-nav-item :active="tab === 5" @click="tab = 5">
                  <i class="fas fa-download icon-nm mr-2 text-dark-50" />
                  DOWNLOAD
                </b-nav-item>
                <b-nav-item :active="tab === 6" @click="tab = 6">
                  <span>
                    <i class="fas fa-share-alt icon-nm text-dark-50" />
                  </span>
                </b-nav-item>
              </b-nav>
            </div>
          </div>
        </div>
      </div>
      <!-- END BARIS 1 -->
    </div>
    <!--end::Dashboard-->
  </div>
</template>

<script>
import axios from 'axios'
import * as echarts from 'echarts'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { LineChart } from 'echarts/charts'
import // TitleComponent,
// TooltipComponent,
// LegendComponent,
// GridComponent,
'echarts/components'

// BUAT LOGO
import { mapGetters } from 'vuex'
import objectPath from 'object-path'

import Sidebar from '@/view/pages/playground/components/Sidebar.vue'
import Topbar from '@/view/pages/playground/components/Topbar.vue'

use([
  CanvasRenderer,
  LineChart,
  // TitleComponent,
  // TooltipComponent,
  // LegendComponent,
  // GridComponent,
])

export default {
  name: 'playground',
  components: {
    echarts,
    Sidebar,
    Topbar,
  },
  data() {
    return {
      chart: null,
      tab: 1,
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    // BUAT LOGO
    siteLogo() {
      const menuAsideLeftSkin = this.layoutConfig('brand.self.theme')
      // set brand logo
      const logoObject = this.layoutConfig('self.logo')

      let logo
      if (typeof logoObject === 'string') {
        logo = logoObject
      }
      if (typeof logoObject === 'object') {
        logo = objectPath.get(logoObject, menuAsideLeftSkin + '')
      }
      if (typeof logo === 'undefined') {
        const logos = this.layoutConfig('self.logo')
        logo = logos[Object.keys(logos)[0]]
      }
      return process.env.BASE_URL + logo
    },
    initChart() {
      axios
        .get(
          // process.env.VUE_APP_BASE_URL +
          //   `/media/data/life-expectancy-table.json`
          process.env.VUE_APP_BASE_URL + `/media/data/vaccination_monitor.json`
        )
        .then((res) => {
          this.chart = echarts.init(this.$refs.myEchart)
          let option = null
          this.chart.showLoading()
          this.chart.hideLoading()

          // let countries = [
          //   'Finland',
          //   'France',
          //   'Germany',
          //   'Iceland',
          //   'Norway',
          //   'Poland',
          //   'Russia',
          //   'United Kingdom',
          // ]
          let provinces = [
            'DKI Jakarta',
            'Jawa Barat',
            'Jawa Timur',
            'Jawa Tengah',
            'Bali',
            'Yogyakarta',
            'Aceh',
          ]
          let datasetWithFilters = []
          let seriesList = []

          echarts.util.each(provinces, function (province) {
            let datasetId = 'dataset_' + province
            datasetWithFilters.push({
              id: datasetId,
              fromDatasetId: 'dataset_raw',
              transform: {
                type: 'filter',
                config: {
                  and: [
                    { dimension: 'date', gte: 1609977600 },
                    { dimension: 'province', '=': province },
                  ],
                },
              },
            })
            seriesList.push({
              type: 'line',
              datasetId: datasetId,
              showSymbol: false,
              name: province,
              endLabel: {
                show: true,
                formatter: function (params) {
                  return params.value[2] + ': ' + params.value[0]
                },
              },
              labelLayout: {
                moveOverlap: 'shiftY',
              },
              emphasis: {
                focus: 'series',
              },
              encode: {
                x: 'date_label',
                y: 'vaccinated',
                label: ['Province', 'Vaccinated'],
                itemName: 'date_label',
                tooltip: ['Vaccinated'],
              },
            })
          })

          console.log('gfddfdf')
          console.log(datasetWithFilters)
          console.log(seriesList)
          console.log('oi')

          option = {
            animationDuration: 10000,
            dataset: [
              {
                id: 'dataset_raw',
                source: res.data,
              },
            ].concat(datasetWithFilters),
            title: {
              text: '',
            },
            tooltip: {
              order: 'valueDesc',
              trigger: 'axis',
            },
            xAxis: {
              type: 'category',
              nameLocation: 'middle',
            },
            yAxis: {
              name: '',
            },
            grid: {
              right: 140,
            },
            series: seriesList,
          }
          console.log(option)

          if (option && typeof option === 'object') {
            console.log('kepanggil sih!')
            this.chart.setOption(option, true)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  computed: {
    // BUAT LOGO
    ...mapGetters(['layoutConfig']),
  },
}
</script>

<style lang="scss" scoped>
.card-footer {
  padding: 0 !important;
}
.chart {
  height: 550px;
  margin-bottom: -3px;
  margin-top: -15px;
}
.judul {
  font-family: Playfair Display, Georgia, Times New Roman, serif;
  font-weight: 400;
  color: #555;
  margin: 0;
  font-size: 23px;
  line-height: 1;
  overflow-y: visible;
  margin-bottom: 4px;
  text-rendering: optimizelegibility;
  -webkit-font-smoothing: antialiased;
}
// tabs
.tabs-below {
  border-bottom-width: 0px;
  border-top: 1px solid #e1e1e1;
  background-color: #fafbfd;
}

.tabs-below .nav-link {
  border: 1px solid transparent;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.tabs-below .nav-item {
  margin-bottom: 0px;
  margin-top: -1px;
}
.nav.nav-tabs .nav-item {
  margin-right: 0;
}

.tabs-below .nav-item a {
  border-left: 1px solid #e1e1e1;
  color: #777;
  display: block;
}

.tabs-below .nav-item.show .nav-link,
.tabs-below .nav-link.active {
  border-bottom: 2px solid #000;
  color: rgba(0, 33, 71, 0.9);
}
</style>
